module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/53wPjOjZAsqeM8IcSQa2I8-3b6a5ea53ff2d33b508c9f33c5d5153b.jpg";